import React from 'react';
import classnames from 'classnames';
import { map, noop, every } from 'lodash';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { resolutionInput as ResolutionInput } from 'ui/views/generic/resolutionInput';
import { moodInput as MoodInput } from 'ui/views/generic/moodInput';
import { button as Button } from 'modules/button';
import { getLabel } from 'utils/getLabel';

// success view
export const callDispositionCloseCallSuccess = ( props ) => {

    // widget class name
    const widgetClassName = classnames( 'ui-call-disposition-end-call', props.className );

    return (
        <div className={ widgetClassName }>
            {/* resolution */}
            <div className='ui-call-disposition-end-call__resolution'>
                <ResolutionInput
                    options={ props.options.callResolution }
                    value={ props.callCloseData.callResolution }
                    onChange={ value => props.onCallDataChange( 'callResolution', value ) }
                    disabled={ props.disableResolutionSelection }
                />
            </div>

            {/* mood */}
            <div className='ui-call-disposition-end-call__mood'>
                <MoodInput
                    options={ props.options.callerMood }
                    value={ props.callCloseData.callerMood }
                    onChange={ value => props.onCallDataChange( 'callerMood', value ) }
                />
            </div>

            {/* call id */}
            <div className='ui-call-disposition-end-call__call-id'>
                <div className='ui-call-disposition-end-call__call-id__title'>
                    { getLabel( 'displayTextCallId' ) } -
                </div>

                <div className='ui-call-disposition-end-call__call-id__call-display-id'>
                    { props.callState.callDisplayId }
                    
                    {/* <input
                        type='text'
                        className='ui-call-disposition-end-call__call-id__input__element'
                        value={ props.callCloseData.callTag }
                        onChange={ event => props.onCallDataChange( 'callTag', event.target.value ) }
                    /> */}
                </div>
            </div>

            {/* close call actions */}
            <div className='ui-call-disposition-end-call__actions'>
                {
                    map( props.actions, action => {
                        return (
                            <Button
                                key={ action.name }
                                className='ui-call-disposition-end-call__actions__item'
                                title={ action.title }
                                size='extra-small'
                                disabled={ ! ( every( props.callCloseData ) && props.callReasonValidationState && props.callNotesValidationState ) }
                                onClick={ props.onCallClose }
                            />
                        );
                    } )
                }
            </div>
        </div>
    );
};

// set display name
callDispositionCloseCallSuccess.displayName = 'callDispositionCloseCallSuccess';

// set default props
callDispositionCloseCallSuccess.defaultProps = {
    options: {},
    actions: [],
    onCallDataChange: noop,
    onCallClose: noop,
    disableResolutionSelection: false,
};

// prop types
callDispositionCloseCallSuccess.propTypes = {};


/*******************************/

// preloader view
export const callDispositionCloseCallPreloader = ( props ) => {

    // widget class name
    const widgetClassName = classnames( 'ui-call-disposition-end-call-preloader', props.className );

    return (
        <div className={ widgetClassName } />
    );
};

// set display name
callDispositionCloseCallPreloader.displayName = 'callDispositionCloseCallPreloader';

// set default props
callDispositionCloseCallPreloader.defaultProps = {};

// prop types
callDispositionCloseCallPreloader.propTypes = {};

/*******************************/


/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { callDispositionCloseCall as callDispositionCloseCall } from 'ui/views/widgets/callDispositionCloseCall';
 *
 * // render
 * <callDispositionCloseCall propName='propValue'/>
 */
export const callDispositionCloseCall = withNetworkState( callDispositionCloseCallPreloader, callDispositionCloseCallSuccess );
